<template>

  <div class="container">
    <div id="particles">
      <vue-particles color="#dedede"></vue-particles>
    </div>

    <div id="loginbox" class="mainbox col-lg-6 col-md-6 ml-auto mr-auto">
      <div class="card card-default">
          <div class="logo-image mr-auto">
              <img src="../assets/image/title-logo.png"  alt=""/>
          </div>
        <div class="card-body">
          <form name="form" id="form" class="form-horizontal" @submit.prevent="handleLogin()">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i class="nc-icon nc-email-85"></i>
                </div>
              </div>
              <input
                id="user"
                type="email"
                class="form-control"
                :placeholder="$t('login.placeholder_email')"
                v-model="form.email"/>
            </div>
            <div class="row text-danger">
              <div class="col">
                <div v-if="formSubmitted && (formInvalid || error)">
                  <p v-if="!$v.form.email.required">{{ $t('common_errors.required', {field: $t('common.mail_address')}) }}</p>
                  <p v-if="!$v.form.email.email">{{ $t('message_error.EMAIL_INVALID') }}</p>
                </div>
              </div>
            </div>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-lock"></i>
                </span>
              </div>
              <input
                id="password"
                type="password"
                class="form-control"
                :placeholder="$t('common.password')"
                v-model="form.password"/>
            </div>
            <div class="row text-danger">
              <div class="col">
                <div v-if="formSubmitted && (formInvalid || error)">
                  <div v-if="error" class="alert alert-danger">
                    <font-awesome-icon :icon="['far', 'circle-xmark']" class="pr-1"/>
                    {{ error }}
                  </div>
                  <div v-if="!$v.form.password.required" class="alert alert-danger">
                    <font-awesome-icon :icon="['far', 'circle-xmark']" class="pr-1"/>
                    {{ $t('common_errors.required', {field: $t('common.password')}) }}
                  </div>
                  <div v-if="!$v.form.password.minLength" class="alert alert-danger">
                    <font-awesome-icon :icon="['far', 'circle-xmark']" class="pr-1"/>
                    {{ $t('common_errors.password_invalid', {min: this.$v.form.password.$params.minLength.min }) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" v-model="form.save_login" />
                      <span class="form-check-sign"></span>
                      {{ $t('login.remember_me')}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <i class="nc-icon nc-lock-circle-open"></i>
                  {{ $t('login.forgot_password') }}
                  <a v-bind:href="resetPasswordURL">
                      {{ $t('login.your_password')}}
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <i class="nc-icon nc-button-power"></i>
                  <a v-bind:href="signupURL">
                      {{ $t('login.signup')}}
                  </a>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12 controls text-center">
                  <button type="submit" value="login" href="#" class="btn btn-primary btn-round">
                    <i class="fa fa-sign-in"></i> {{ $t('login.login')}}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import AuthService from "../services/AuthService";
import router from "../router";
import { ERRORS_CODE } from "../const/error_code";

const BACKEND_URL = process.env.VUE_APP_BACKEND_HOST;

export default {
  name: "Login",
  data() {
    return {
      resetPasswordURL : BACKEND_URL + "/accounts/password/reset/",
      signupURL : BACKEND_URL + "/accounts/signup/",
      error: '',
      formInvalid: false,
      form: {
        email: "",
        password: "",
        save_login: false,
      },
      formSubmitted: false
    };
  },
  validations: {
    form: {
      email: { required, email },
      password: { required, minLength: minLength(6) }
    }
  },
  methods: {
    handleLogin() {
      this.formSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.formInvalid = this.$v.$invalid;
      } else {
        this.submitForm();
      }
    },
    submitForm() {

      // Save email and save_login to localStorage
      if (this.form.save_login) {
        localStorage.setItem("save_login", this.form.save_login);
        localStorage.setItem("email", this.form.email);
      } else {
        localStorage.removeItem("save_login");
        localStorage.removeItem("email");
      }

      AuthService.login(this.form).then(response => {
          this.formSubmitted = false;
          AuthService.saveToken(JSON.stringify(response.data.data.token));
          AuthService.saveUserCurrentLogin(response.data.data.user);
          AuthService.saveOrganizationId(response.data.data.organization.id);
          router.push({ name: "dashboard" });
      }).catch((error) => {
          if (error.response.data.errorCode == ERRORS_CODE.ACCOUNT_IS_LOCKED) {
            this.error = this.$t('message_error.ACCOUNT_IS_LOCKED', {
                datetime: new Date(error.response.data.data).toLocaleString()
              });
          } 
          else if (error.response.data.errorCode == ERRORS_CODE.EMAIL_NOT_VERIFIED) {
            this.error = this.$t('message_error.EMAIL_NOT_VERIFIED');
          }
          else {
            this.error = this.$t('message_error.WRONG_PASSWORD_OR_EMAIL');
          }
      });
    }
  },
  created() {
    document.title = this.$t(`${this.$route.meta.title}.title_page`);

    // Load email and save_login from localStorage
    if (localStorage.getItem("save_login")) {
      this.form.email = localStorage.getItem("email");
      this.form.save_login = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/pages/login.scss";
body {
  background-color: whitesmoke;
  #loginbox{
    margin-top: 9rem;
  }
}
</style>
